import { render } from "./SubjectFlexibleILOs.component.vue?vue&type=template&id=eb9ee842&ts=true"
import script from "./SubjectFlexibleILOs.component.vue?vue&type=script&lang=ts"
export * from "./SubjectFlexibleILOs.component.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__